import React, { useState, useEffect, useMemo } from 'react';

import {Row, Col, Input, Container} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFlag} from '@fortawesome/free-regular-svg-icons'
import Pagination from 'react-js-pagination';
import {useTranslation} from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';
import { CatalogoAPI, ConsultaAPI } from '../../../../shared/http-requests';
import { SpinnerConstructor } from "../../../../shared/components";
import classNames from 'classnames'

import transp from '../../../../../images/transp.svg';
import  defaultBackgroundImage  from '../../../../../images/defaultBackgroundImage.png'
import GenericCarousel from '../../../../shared/components/GenericCarousel';
import { connect } from 'react-redux';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';
import Axios from 'axios';
import AppCover from '../../../../shared/components/AppCover';

const PergamumCarousel = React.lazy(() => import('../../../../shared/components/PergamumCarousel'))

/**
 * Componente Secoes
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param secoes
 * @param guiaSelecionada
 * @param props
 * @returns {*|JSX.Element}
 * @constructor
 */
const Secoes = ({secoes, guiaSelecionada, ...props}) => {

    const [destaques, setDestaques] = useState([]);
    const [noticias, setNoticias] = useState([]);
    const [pagination, setPagination] = useState({})
    const { codAcervo } = useParams()
    const { showDestaques: showSectionDestaques} = useAppContext()


    const showDestaques = () => {
        const destaques = document.getElementById('destaques')
        destaques.classList.toggle('d-none')
    }

    const {t} = useTranslation();

    const [selectOrderBy, setSelectOrderBy] = useState([
        {label: t('Titulo'), value: 'obra'},
        {label: t('AnoPublicacao'), value: 'ano_publicacao'},
        {label: t('CodigoAcervo'), value: 'cod_acervo'},
        {label: t('TipoObra'), value: 'cod_tipo_obra'},
        {label: t('Idioma'), value: 'idioma'},
        {label: t('DescricaoFisica'), value: 'desc_fisica'},
        {label: t('Classificacao'), value: 'classificacao'},
        {label: t('Referencia'), value: 'referencia'},
    ])

    const [selectedOrderBy, setSelectedOrderBy] = useState('obra')

    const selectPerPage = [7, 14, 21, 28, 35, 42, 49]

    const [selectedPerPage, setSelectedPerPage] = useState(selectPerPage[0]);

    const [loadingDestaques, setLoadingDestaques] = useState(false)

    const { instituicaoRx: { capa_cor_fonte_padrao_classico, capa_padrao_classico} = {
        capa_cor_fonte_padrao_classico: '#000000',
        capa_padrao_classico: defaultBackgroundImage,
        usa_capa_padrao_classico: 'N'
    }} = props;

    const {lang} = useAppContext();

    useEffect(() => {
        const targetDiv = document.querySelector('.consultaContent');
        if(targetDiv)
            targetDiv.scrollIntoView({ behavior: 'smooth' });
    }, [codAcervo])


    /**
     * Busca noticia
     */
    useEffect( () => {
        const cancelTokenSrc = Axios.CancelToken.source();
        (async () => {
            const hasSection = secoes.some(x => x.tipo_secao.toLowerCase() === 'noticias')
            if(!hasSection) return;

            try{
                const response = await CatalogoAPI.buscarNoticias(guiaSelecionada, cancelTokenSrc.token)
                if(response){
                    const { data } = response;

                    if(data){
                        const {data} = response;
                        if (data) {
                            /**
                             * Agrupando de 3 em 3 noticias para o slide
                             */
                            const totalNoticias = data?.length;
                            const noticiasAgrupadas = [];

                            for (let i = 0; i < totalNoticias; i++) {
                                if (i % 3 == 0) {
                                    noticiasAgrupadas.push(data.slice(i, i + 3))
                                    continue;
                                }
                            }

                            setNoticias(noticiasAgrupadas);
                        }
                    }
                }
            }catch (e) {
                if(!Axios.isCancel(e))
                    setLoadingDestaques(false)
            }
        })();

        return () => {
            cancelTokenSrc.cancel()
        }
    }, [lang])


    /**
     * Busca destaques
     */
    useEffect( () => {
        const cancelTokenSrc = Axios.CancelToken.source();
        (async() => {
            await findDestaques({}, cancelTokenSrc.token);
        })();

        return () => {
            cancelTokenSrc.cancel()
        }
    }, [])



    const findDestaques = async ({page = 1, perPage = selectedPerPage, orderBy = selectedOrderBy}, cancelToken = null) => {
        const hasDestaqueSection = secoes.some(x => x.tipo_secao.toLowerCase() === 'destaque')
        if(!hasDestaqueSection) return;
        try{
            const response = await  CatalogoAPI.buscarDestaques({ page, perPage, orderBy }, cancelToken)
            if(response){
                const { data } = response;

                if(data){
                    const {data} = response;
                    if (data) {
                        const { destaques, pagination} = data;
                        setDestaques(destaques);
                        setPagination(pagination);
                    }
                }

                setLoadingDestaques(false)
            }
        }catch (e) {
            if(!Axios.isCancel(e)){
                console.log(e)
                setLoadingDestaques(false)
            }
        }
    }

    /**
     *
     * @param secao
     * @returns {JSX.Element}
     */
    const renderizarDestaques = (secao) => {
        return (destaques?.length && destaques?.length != null) && (
            <div className={'p-2'}>
                <div className={'destaques bkbranco p-2'}>
                    <div className={'bkbranco'}>
                        <Col md={'12'} className="col-12  py-3">
                            <Row>
                                <Col className={'d-flex  align-items-center'}>
                                    <h3 className="s24 cortxt mb-0 inline">{secao.nome_secao}</h3>
                                </Col>
                                <div className="d-md-none bkbranco">
                                    <label onClick={showDestaques}
                                           className="l20 f500 branco hover hpreto bklaranja px-2 py-1 rad5 click slaranja">
                                        {t('Mostrar')}
                                    </label>
                                </div>
                            </Row>
                        </Col>
                        <div className={'d-none  d-md-block'} id={'destaques'}>
                            <Row className={classNames('container m-auto px-md-0 pb-4',{
                                ['d-flex justify-content-end']: pagination?.lastPage <= 1
                            })}>
                                {
                                    pagination?.lastPage > 1 ? (
                                        <Col className='d-flex justify-content-start flex align-items-end px-md-0'>
                                            <Pagination
                                                innerClass='pagination m-0'
                                                hideDisabled
                                                itemClass="page-item b-cinza"
                                                linkClass="page-link f400 preto op07"
                                                activeLinkClass="branco f900 bkzero op10"
                                                activeClass="bktema rad5"
                                                activePage={pagination.currentPage}
                                                itemsCountPerPage={pagination.perPage}
                                                totalItemsCount={pagination.totalItems}
                                                onChange={page => {
                                                    if (page == pagination.currentPage) {
                                                        return;
                                                    }
                                                    findDestaques({page})
                                                }}
                                                nextPageText={
                                                    <FontAwesomeIcon icon="angle-right"/>
                                                }
                                                prevPageText={
                                                    <FontAwesomeIcon icon="angle-left"/>
                                                }
                                                firstPageText={
                                                    <FontAwesomeIcon icon="angle-double-left"/>
                                                }
                                                lastPageText={
                                                    <FontAwesomeIcon icon="angle-double-right"/>
                                                }
                                            />
                                        </Col>
                                    ) : null
                                }
                                <Col md='3' lg='2'>
                                    <div>
                                        <div>
                                            <span className="s13 cortxt f500">Ordenar por:</span>
                                        </div>
                                        <Input name="ordenacao" type={'select'} value={selectedOrderBy || ''}
                                               onChange={(e) => {
                                                   const { value } = e.currentTarget;
                                                   setSelectedOrderBy(value);
                                                   setLoadingDestaques(true);
                                                   findDestaques({ orderBy: value });
                                               }}>
                                            {
                                                selectOrderBy.map((item) => (
                                                    <option  key={`top_order-option_${item.value}`} value={item.value}>{item.label}</option>
                                                ))
                                            }
                                        </Input>
                                    </div>
                                </Col>
                                <Col className='px-md-0 items-per-page' md='3' lg='2'>
                                    <div>
                                        <span className="s13 cortxt f500">Itens por página:</span>
                                    </div>
                                    <Input type={'select'} name="quantPerPag" value={selectedPerPage || ''}
                                           onChange={(e) => {
                                               const { value } = e.currentTarget;
                                               setSelectedPerPage(value);
                                               setLoadingDestaques(true);
                                               findDestaques({ perPage: value });

                                           }}>
                                            {
                                                selectPerPage.map((item) => (
                                                    <option key={`top_per_page_option_${item}`}  value={item}>{item}</option>
                                                ))
                                            }
                                    </Input>
                                </Col>
                            </Row>
                            <div className={'novasAquisicoesTipoLista py-2'}>
                                <Row>
                                    <ul className={'__coverList container m-auto  p-0'}>
                                        {
                                            destaques && destaques?.length && destaques?.length != null && 
                                            loadingDestaques && (
                                                <div className="p-5 text-center animated fadeIn">
                                                    <SpinnerConstructor
                                                        visible
                                                        showLabel
                                                        height={80}
                                                        width={80}
                                                        className="apergamum"
                                                    />
                                                </div>
                                            ) ||
                                            destaques.map((destaque, index) => (
                                                <div
                                                    key={`destaque_${index}`}
                                                    style={{width:'150px'}}>
                                                    <AppCover
                                                        isbn={destaque?.isbn_issn}
                                                        codAcervo={destaque?.cod_acervo}
                                                        width='100%'
                                                        height='100%'
                                                        title={destaque.obra}
                                                        link={`acervo/${destaque?.cod_acervo}`}
                                                        src={destaque['link_capa']}
                                                        textColor={capa_cor_fonte_padrao_classico}
                                                        altSrc={capa_padrao_classico}
                                                    />
                                                </div>

                                                //
                                                // <li  key={`destaque_${index}`} className={'__cover'}
                                                //     style={{width: '150px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)'}}>
                                                //     <Link
                                                //         onClick={(e) => {
                                                //             if(destaque.cod_acervo == codAcervo) {
                                                //                 e.preventDefault();
                                                //                 const targetDiv = document.querySelector('.consultaContent');
                                                //                 if(targetDiv)
                                                //                     targetDiv.scrollIntoView({ behavior: 'smooth' });
                                                //             }
                                                //         }}
                                                //         to={`/acervo/${destaque.cod_acervo}`}>
                                                //         <div className='__item h-100 d-flex justify-content-center align-items-center'>
                                                //             {
                                                //                 destaque.link_capa && (
                                                //                     <img src={destaque.link_capa.substr(1)} alt={destaque.obra}
                                                //                          className={'img-fluid'}/>
                                                //                 ) || (
                                                //                     <>
                                                //                         <img src={capa_padrao_classico} alt={destaque.obra}
                                                //                              className={'img-fluid'}/>
                                                //                         <div style={{color: capa_cor_fonte_padrao_classico ?? '#000'}}
                                                //                              className={'__bookName'}>{destaque.obra}</div>
                                                //                     </>
                                                //                 )
                                                //             }
                                                //         </div>
                                                //     </Link>
                                                // </li>
                                            ))
                                        }
                                    </ul>
                                </Row>
                            </div>

                            {
                                pagination?.perPage > 7 && pagination?.totalItems > 7 ? (
                                    <Row className={classNames('container m-auto px-md-0',{
                                        ['d-flex justify-content-end']: pagination?.lastPage <= 1
                                    })}>
                                        {
                                            pagination?.lastPage > 1 ? (
                                                <Col className='d-flex justify-content-start flex align-items-end px-md-0'>
                                                    <Pagination
                                                        innerClass='pagination m-0'
                                                        hideDisabled
                                                        itemClass="page-item b-cinza"
                                                        linkClass="page-link f400 preto op07"
                                                        activeLinkClass="branco f900 bkzero op10"
                                                        activeClass="bktema rad5"
                                                        activePage={pagination.currentPage}
                                                        itemsCountPerPage={pagination.perPage}
                                                        totalItemsCount={pagination.totalItems}
                                                        onChange={page => {
                                                            if (page == pagination.currentPage) {
                                                                return;
                                                            }
                                                            findDestaques({page})
                                                        }}
                                                        nextPageText={
                                                            <FontAwesomeIcon icon="angle-right"/>
                                                        }
                                                        prevPageText={
                                                            <FontAwesomeIcon icon="angle-left"/>
                                                        }
                                                        firstPageText={
                                                            <FontAwesomeIcon icon="angle-double-left"/>
                                                        }
                                                        lastPageText={
                                                            <FontAwesomeIcon icon="angle-double-right"/>
                                                        }
                                                    />
                                                </Col>
                                            ) : null
                                        }
                                        <Col md='3' lg='2'>
                                            <div>
                                                <div>
                                                    <span className="s13 cortxt f500">Ordenar por:</span>
                                                </div>
                                                <Input name="ordenacao" type={'select'} value={selectedOrderBy || ''}
                                                       onChange={(e) => {
                                                           const { value } = e.currentTarget;
                                                           setSelectedOrderBy(value);
                                                           setLoadingDestaques(true);
                                                           findDestaques({ orderBy: value });
                                                       }}>
                                                    {
                                                        selectOrderBy.map((item) => (
                                                            <option  key={`bottom_order-option_${item.value}`} value={item.value}>{item.label}</option>
                                                        ))
                                                    }
                                                </Input>
                                            </div>
                                        </Col>
                                        <Col className='px-md-0 items-per-page' md='2' lg='2'>
                                            <div>
                                                <span className="s13 cortxt f500">Itens por página:</span>
                                            </div>
                                            <Input  type={'select'} name="quantPerPag" value={selectedPerPage || ''}
                                                    onChange={(e) => {
                                                        const { value } = e.currentTarget;
                                                        setSelectedPerPage(value);
                                                        setLoadingDestaques(true);
                                                        findDestaques({ perPage: value });

                                                    }}>
                                                {
                                                    selectPerPage.map((item) => (
                                                        <option key={`bottom_per_page_option_${item}`}  value={item}>{item}</option>
                                                    ))
                                                }
                                            </Input>
                                        </Col>
                                    </Row>
                                ) : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
        ) || (<div/>)
    }

    const renderNews = noticia => {
        const hasLink = noticia.url !== null && noticia.url?.trim() !== '';

        return (
            <div
                style={{backgroundColor: 'rgba(var(--branco), .2)'}}
                className="img-fluid imgCarousel d-inline-block w-100">
                {
                    noticia.nom_imagem ? (
                        <div className="text-center rad10">
                            <img
                                src={transp}
                                alt={noticia.titulo || 'Noticia'}
                                className="img-fluid rad10"
                                style={{
                                    backgroundImage: `url(${noticia.nom_imagem})`,
                                    backgroundSize: 'contain',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    maxHeight: 150,
                                }}
                            />
                        </div>
                    ) : ''
                }

                <div className="preto  f300 s20 p-3">
                    <div
                        className={classNames(
                            'preto f500 p-1 rad10 s20',
                            {
                                click: hasLink,
                            },
                        )}
                    >
                        {noticia.titulo}
                    </div>
                    <div
                        className="s13 preto op70 f400 d-block text-wrap overflow-auto"
                        style={noticia.nom_imagem ? { height: 85} : {}}
                    >
                        {noticia.conteudo}
                    </div>
                </div>
            </div>
        );
    };



    /**
     *
     * @param url
     * @returns {string|*}
     */
    const getUrl = url => {
        if (url === null || url.trim() === '') {
            return '#';
        }

        const pattern = /^http|https/;

        if (!pattern.test(url.trim())) {
            return `http://${url.trim()}`;
        }

        return url;
    };


    /**
     *Todo unificar em um unico componente para kids e classico
     * @param secao
     * @returns {JSX.Element}
     */
    const renderizarNoticias = (secao) => {
        const sliderData = noticias.map((grupoNoticias, index) => {
            return {
                content: (
                    <div key={index} className="zero carouselM">
                        <div className="janela">
                            <div className="horizontal row">
                                <div className={'col-12'}>
                                    {
                                        grupoNoticias?.length > 0 ? grupoNoticias.map(noticia => (
                                            <Col
                                                key={noticia.id_noticia}
                                                md={4}
                                            >
                                                {noticia.url ? (
                                                    <Link
                                                        to={{
                                                            pathname:
                                                                getUrl(
                                                                    noticia.url,
                                                                ),
                                                        }}
                                                        target="_blank"
                                                    >
                                                        {renderNews(
                                                            noticia,
                                                        )}
                                                    </Link>
                                                ) : (
                                                    renderNews(noticia)
                                                )}
                                            </Col>
                                        )) : ''
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        })


        return noticias.length ? (
            <div className="">
                <div className="bktema10 p-2">
                    <div className="container">
                        <h3 className="s24 cortxt mb-0 inline">{secao.nome_secao}</h3>
                    </div>
                    <Container className="pb-5 p-1">
                        <GenericCarousel className="carouselNoticias">
                            {noticias?.length &&
                                noticias.map((grupo, index) => (
                                    <Row key={index} className="w-100">
                                        {grupo?.length &&
                                            grupo.map(noticia => (
                                                <Col
                                                    key={noticia.id_noticia}
                                                    md={4}
                                                >
                                                    {noticia.url ? (
                                                        <Link
                                                            to={{
                                                                pathname:
                                                                    getUrl(
                                                                        noticia.url,
                                                                    ),
                                                            }}
                                                            target="_blank"
                                                        >
                                                            {renderNews(
                                                                noticia,
                                                            )}
                                                        </Link>
                                                    ) : (
                                                        renderNews(noticia)
                                                    )}
                                                </Col>
                                            ))}
                                    </Row>
                                ))}
                        </GenericCarousel>
                    </Container>
                </div>
            </div>
        ) : ''
    }


    /**
     * Renderização condicional
     */
    if (secoes.length) {
        return secoes.map((secao) => {
            switch (secao.tipo_secao) {
                case 'DESTAQUE':
                    return showSectionDestaques ?  (
                        <div key={secao.tipo_secao}>
                            {renderizarDestaques(secao)}
                        </div>
                    ) : ''
                case 'NOTICIAS':
                    return (
                        <div key={secao.tipo_secao}>
                            {renderizarNoticias(secao)}
                        </div>
                    )
                default:
                    return ''
            }
        })
    }

    return (<div/>)
}


function mapStateToProps(state) {
    return {
        instituicaoRx: state.instituicao.data,
    };
}

export default connect(mapStateToProps)(Secoes);
